<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="avisos">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
          >
            <a @click="editAvisos(-1)" class="p-3">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Novo Aviso</span>
            </a>
          </div>
        </div>
      </div>
      <template slot="thead">
        <vs-th sort-key="id">ID</vs-th>
        <vs-th sort-key="name">Descrição</vs-th>
        <vs-th sort-key="initDate">Data Hora Início</vs-th>
        <vs-th sort-key="endDate">Data Hora Fim</vs-th>
        <vs-th sort-key="clicks">Views</vs-th>
        <vs-th sort-key="aproves">Aprovado</vs-th>
        <vs-th sort-key="active">Ativado</vs-th>
      </template>
      <template>
        <tbody>
          <vs-tr
            :class="`card-user row-list`"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in avisos"
          >
            <vs-td>
              <a @click="editAvisos(tr.id_aviso)">
                <p class="font-medium">{{ tr.id_aviso }}</p>
              </a>
            </vs-td>
            <vs-td>
              <p
                v-if="tr.nome && tr.nome.toString().length > 60"
                class="font-medium"
              >
                <a @click="editAvisos(tr.id_aviso)">
                  {{ tr.nome.substring(0, 60) }}
                </a>
                <a @click="detailColumn('Nome', tr.nome)"><b>...</b></a>
              </p>
              <p v-else class="font-medium">
                <a @click="editAvisos(tr.id_aviso)">{{ tr.nome }}</a>
              </p>
            </vs-td>
            <vs-td>
              <p class="font-medium">{{ tr.data_hora_inicio }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium">{{ tr.data_hora_fim }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium">{{ tr.cliques }}</p>
            </vs-td>
            <vs-td>
              <vs-checkbox
                @click="alteraAprovadoGestao(tr.id_aviso)"
                :false-value="false"
                :true-value="true"
                class="mb-3"
                v-model="tr.aprovado_gestao"
              ></vs-checkbox>
            </vs-td>
            <vs-td>
              <i-switch
                @on-change="alteraStatus(tr.id_aviso)"
                size="large"
                v-model="tr.ativo"
                :false-value="0"
                :true-value="1"
              >
                <span slot="open">ON</span>
                <span slot="close">OFF</span>
              </i-switch>
            </vs-td>
            <vs-td>
              <a @click="deletaAviso(tr.id_aviso)">
                <Button
                  class="button-trash"
                  icon="ios-trash-outline"
                  shape="circle"
                  size="large"
                  ghost
                  type="error"
                  style="margin-right: 5px"
                  :id="tr.id_aviso"
                ></Button>
              </a>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <drawer placement="right" title="Aviso" v-model="edit" width="850">
      <aviso
        :id="edit_id"
        @fecharDrawer="
          edit = $event;
          getAvisos();
        "
        v-on:atualizaLista="getAvisos"
        v-if="edit && edit_id"
      ></aviso>
    </drawer>
    <vs-prompt
      vs-buttons-hidden
      :vs-title="prompt.title"
      :vs-active.sync="prompt.show"
    >
      <vs-textarea v-model="prompt.text" class="mt-3 w-full" height="400" />
      <div class="flex justify-end">
        <vs-button @click="copyText">Copiar</vs-button>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
const _ = require("lodash");

export default {
  components: {
    aviso: () => import("./aviso.vue"),
  },
  data() {
    return {
      avisos: [],
      isMounted: false,
      edit: false,
      edit_id: 0,
      prompt: {
        show: false,
        title: "",
        text: "",
      },
    };
  },
  methods: {
    permissaoAlterar() {
      /**
       * Permissão: Administração
       */
      return [1, 2].includes(this.$store.getters.usuario.usuario_cargo);
    },
    async alteraAprovadoGestao(id_aviso) {
      const idx = _.findIndex(this.avisos, (o) => o.id_aviso === id_aviso);

      if (!this.permissaoAlterar()) {
        this.$vs.notify({
          title: "Erro",
          text: "Sem permissão para aprovar o aviso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        this.avisos[idx].aprovado_gestao = !this.avisos[idx].aprovado_gestao;
        return;
      }

      try {
        await this.$axios.put(`aviso/${id_aviso}/alteraAprovadoGestao`, {
          aprovado_gestao: !this.avisos[idx].aprovado_gestao,
        });
        this.$vs.notify({
          title: "Sucesso",
          text: `Aviso ${id_aviso} alterado com sucesso!`,
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "rgb(0,155,8)",
          position: "top-right",
        });
      } catch (ex) {
        console.warn(ex);
        this.getAvisos();
      }
    },
    async getAvisos() {
      try {
        const { data } = await this.$axios.get(`aviso`);
        this.avisos = data;
      } catch (ex) {
        console.warn(ex);
      }
    },
    async alteraStatus(id_aviso) {
      const idx = _.findIndex(this.avisos, (o) => o.id_aviso === id_aviso);

      if (
        !this.permissaoAlterar() ||
        this.avisos[idx].aprovado_gestao === false
      ) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possível alterar o status do aviso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        this.getAvisos();
        return;
      }

      try {
        await this.$axios.put(`aviso/${id_aviso}/alteraAtivo`, {
          ativo: this.avisos[idx].ativo,
        });

        await this.criaDeletaNotificacao(idx);

        this.$vs.notify({
          title: "Sucesso",
          text: `Aviso ${id_aviso} alterado com sucesso!`,
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "rgb(0,155,8)",
          position: "top-right",
        });
      } catch (ex) {
        console.warn(ex);
        this.getAvisos();
      }
    },
    async criaDeletaNotificacao(idx) {
      try {
        const empresa = this.avisos[idx].empresa;

        this.avisos[idx].empresa =
          typeof empresa === "string" ? JSON.parse(empresa) : empresa;

        if (this.avisos[idx].ativo === 0) {
          await this.$axios.delete(`notification/${this.avisos[idx].id_aviso}`);
        } else {
          await this.$axios.post(`notification`, this.avisos[idx]);
        }
      } catch (err) {
        console.warn(err);
      }
    },
    detailColumn(title, text) {
      this.prompt = {
        show: true,
        title,
        text,
      };
    },
    copyText() {
      this.prompt.show = false;
      const text = this.prompt.text;
      this.$copyText(text).then(
        () => {
          this.$vs.notify({
            text: "Texto copiado.",
            color: "success",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-check-circle",
          });
        },
        () => {
          this.$vs.notify({
            text: "Erro ao copiar texto.",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
          });
        }
      );
    },
    /**
     * Método para deletar um determinado aviso.
     */
    async deletaAviso(id_aviso) {
      if (!this.permissaoAlterar()) {
        this.$vs.notify({
          title: "Erro",
          text: "Sem permissão para deletar o aviso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        this.getAvisos();
        return;
      }

      const result = await this.confirmaDeletaAviso(id_aviso);
      if (!result) return;

      try {
        await this.$axios.delete(`aviso/${id_aviso}`);

        /**
         * Se deletar um aviso, estará, consequentemente,
         * deletando uma notificação.
         */
        await this.$axios.delete(`notification/${id_aviso}`);

        this.$vs.notify({
          title: `Aviso com o id ${id_aviso} foi deletado com sucesso!`,
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "rgb(0,155,8)",
          position: "top-right",
        });
      } catch (ex) {
        console.warn(ex);
      }

      this.getAvisos();
    },
    async confirmaDeletaAviso(id_aviso) {
      return new Promise((resolve) => {
        this.$Modal.confirm({
          title: `Aviso ${id_aviso}`,
          content: "Deseja realmente deletar este aviso?",
          cancelText: "Não",
          okText: "Sim",
          onOk: () => {
            resolve(1);
          },
        });
      });
    },
    /**
     * Abre o drawer para edição do ticket
     */
    editAvisos(id) {
      this.edit_id = id;
      this.edit = true;
    },
  },
  created() {
    this.avisos = this.getAvisos();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .card-user .more-option {
      visibility: hidden;
    }

    .card-user:hover .more-option {
      visibility: visible;
    }

    .inativo {
      color: #909090;
      background-color: #f6f6f6;
    }
  }
}

.button-trash {
  visibility: hidden;
}

.row-list:hover .button-trash {
  visibility: visible;
}
</style>
